module.exports = __webpack_public_path__ + "static/UnclickPermanentlyDisabled-9bb61338733bbcd7b401707c0461940e.png";